<template>
   <HeaderDash />
   <SideMenu /> 
   <ContentProfile /> 
</template>
<script>

import HeaderDash from '@/components/worker/dashboard/HeaderDash.vue'
import SideMenu from '@/components/worker/dashboard/SideMenu.vue'
import ContentProfile from '@/components/worker/dashboard/modules/setting/profile/ContentProfile.vue'

export default 
{
  name: 'Worker-Profile',
  components: 
  {
    HeaderDash,
    SideMenu,
    ContentProfile
  }
}
</script>
<style>


</style>